/**
 * ニュースカテゴリ切替時、表示中リストの件数に合わせて
 * .ol-news__body の高さを更新する。
 * 親テーマは横並び4リストの最大高で .ol-news__body が固定されるため上書きする。
 */
export default class NewsListHeight {
  constructor() {
    this.body = document.querySelector('.ol-news__body.ol-news__category-on');
    if (!this.body) return;

    this.lists = this.body.querySelectorAll('.js-news-content');
    this.navItems = document.querySelectorAll('.js-news-nav-item');
    if (!this.lists.length) return;

    this.update = this.update.bind(this);
    this.onResize = this.onResize.bind(this);

    this.update();
    window.addEventListener('load', this.update);
    window.addEventListener('resize', this.onResize);

    this.navItems.forEach((item) => {
      item.addEventListener('click', () => {
        // 親テーマの is-active 付与後に測る
        requestAnimationFrame(() => {
          requestAnimationFrame(this.update);
        });
      });
    });
  }

  getActiveList() {
    return this.body.querySelector('.js-news-content.is-active') || this.lists[0];
  }

  /** flex の stretch 影響を受けないよう、子要素の合計で実高さを算出 */
  measureListHeight(list) {
    let height = 0;
    list.querySelectorAll(':scope > li').forEach((item) => {
      height += item.offsetHeight;
    });
    const style = window.getComputedStyle(list);
    height += parseFloat(style.paddingTop) || 0;
    height += parseFloat(style.paddingBottom) || 0;
    return height;
  }

  update() {
    const active = this.getActiveList();
    if (!active) return;
    this.body.style.height = `${this.measureListHeight(active)}px`;
  }

  onResize() {
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(this.update, 100);
  }
}
